import { Box, CircularProgress } from '@mui/material';
import { User } from 'types/User';
import { ShippingDetailsCard } from './ShippingDetailsCard';
import { ShippingDetailsForm } from './ShippingDetailsForm';

export enum ShippingDetailsSectionStateType {
  LOADING = 'LOADING',
  FROM_PROFILE = 'USE_FROM_PROFILE',
  PROFILE_INCOMPLETE = 'PROFILE_INCOMPLETE',
  CUSTOM = 'CUSTOM'
}

export type ShippingDetailsSectionState =
  | { type: ShippingDetailsSectionStateType.LOADING }
  | { type: ShippingDetailsSectionStateType.PROFILE_INCOMPLETE }
  | { type: ShippingDetailsSectionStateType.FROM_PROFILE; userProfile: User }
  | { type: ShippingDetailsSectionStateType.CUSTOM };

export const ShippingDetailsSection: React.FC<{
  state: ShippingDetailsSectionState;
  switchToCustomDetails: () => void;
}> = ({ state, switchToCustomDetails }) => {
  switch (state.type) {
    case ShippingDetailsSectionStateType.LOADING:
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      );
    case ShippingDetailsSectionStateType.PROFILE_INCOMPLETE:
      return <ShippingDetailsForm profileIsIncomplete />;
    case ShippingDetailsSectionStateType.CUSTOM:
      return <ShippingDetailsForm />;
    case ShippingDetailsSectionStateType.FROM_PROFILE:
      return (
        <ShippingDetailsCard
          userProfile={state.userProfile}
          switchToCustomDetails={switchToCustomDetails}
        />
      );
  }

  return null;
};
